<template>
    <div class="">
        <div v-if="vouchers">
            <table class="table">
                <thead>
                <tr class="row m-0">
                    <th class="col-md-5">Lék</th>
                    <th class="col-md-1">Diagnóza</th>
                    <th class="col-md-1">Hradí pacient</th>
                    <th class="col-md-1">Počet bal.</th>
                    <th class="col-md-1">Dávkování</th>
                    <th class="col-md-2">Předepsáno</th>
                    <th class="col-md-1"></th>
                </tr>
                </thead>
                <tbody>
                <template v-for="(m, index) in vouchers" class="card-text">
                    <tr class="row m-0">
                        <td class="align-middle col-md-5">
                          {{ m.medicine ? m.medicine.label : '' }}
                          {{ m.individual_medicine ? m.individual_medicine.name : '' }}
                        </td>
                        <td class="align-middle col-md-1">
                            {{ m.disease !== null ? m.disease.code : ''}}
                        </td>
                        <td class="align-middle col-md-1">
                            {{ m.paid_by_sick | boolToCS }}
                        </td>
                        <td class="align-middle col-md-1">
                            {{ m.amount }}
                        </td>
                        <td class="align-middle col-md-1">
                            {{ m.dosage }}
                        </td>
                        <td class="text-left col-md-2">
                            {{ m.created_at }}
                          <template v-if="m.prescription">
                            <i class="fa fa-mobile-phone" title="Recept odeslán přes SMS" aria-hidden="true" v-if="m.prescription.patient_notification_type === 'SMS'"></i>
                            <i class="fa fa-envelope-o" title="Recept odeslán přes e-mail" aria-hidden="true" v-else-if="m.prescription.patient_notification_type === 'EMAIL'"></i>
                            <i class="fa fa-ban text-danger" title="Bez notifikace o receptu" aria-hidden="true" v-else></i>
                          </template>
                        </td>
                        <td class="col-md-1 row justify-content-start m-0">
                            <button @click="copyVoucher(m)" class="btn btn-sm btn-primary btn_line-heigh-1" title="kopírovat"><i class="fa fa-clone" aria-hidden="true"></i></button>
                        </td>
                    </tr>
                </template>
                </tbody>
            </table>
        </div>
        <div class="text-center" v-else-if="vouchersPending">
            <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i><br/>
            (načítám)
        </div>
    </div>
</template>

<script>
  import apiMixin from '@/mixins'

  export default {
    data () {
      return {
        vouchers: false,
        vouchersPending: false,
        vouchersError: false
      }
    },
    props: ['doUpdate'],
    mixins: [apiMixin],
    computed: {},
    methods: {
      copyVoucher (voucher) {
        this.$emit('copied', voucher)
        // this.searchSimilarMedicineByVoucher(voucher)
      },
      vouchersListUpdated () {
        this.$emit('updated')
      }
    },
    watch: {
      doUpdate (val) {
        if (val === true) {
          this.getClientVouchers(this.$store.state.clientId, this.$route.params.visitid)
          this.$emit('updated')
        }
      },
      '$route.params.visitid' () {
        this.getClientVouchers(this.$store.state.clientId, this.$route.params.visitid)
      }
    },
    beforeMount () {
      this.getClientVouchers(this.$store.state.clientId, this.$route.params.visitid)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .table th, .table td {
        padding: 1px;
    }

    .no-top-border {
        border-top: none;
    }

    .btn_line-heigh-1 {
        line-height: 1;
    }

</style>



// WEBPACK FOOTER //
// src/views/Visit/components/ListPreviousVoucher.vue?71d0d959